/**
 * The Activity page's address vocabulary. The route's `validateSearch` runs in the
 * console's first-load bundle, so what it reads lives here, importing nothing: reading
 * these from the page or the analytics view would pull those modules, and the Connect
 * runtime with them, into every first page load.
 */

/** Activity's tabs: the Scorecard (a floor manager's default), Operations (a collector's), the
 *  Pod timeline, the Operators lanes, the pod events (`report`), Explore (`analytics`) and the
 *  floor checks (`checks`). */
export const ACTIVITY_VIEWS = ["scorecard", "operations", "pipeline", "operators", "report", "analytics", "checks", "incidents"] as const;
export type ActivityView = (typeof ACTIVITY_VIEWS)[number];

/** The Pod timeline's two viewers of one pod's day: an episode per row, or a lane per
 *  part of the station. */
export const PIPELINE_VIEWERS = ["timeline", "station"] as const;
export type PipelineViewer = (typeof PIPELINE_VIEWERS)[number];

/** Operations' span: one day, or the seven ending on it. */
export const OPERATIONS_SPANS = ["day", "week"] as const;
export type OperationsSpan = (typeof OPERATIONS_SPANS)[number];

export const ANALYTICS_PERIODS = ["today", "week", "month", "custom"] as const;
export type AnalyticsPeriod = (typeof ANALYTICS_PERIODS)[number];

export const EXPLORE_CHARTS = [
  "bars",
  "stacked",
  "line",
  "area",
  "heatmap",
  "donut",
  "treemap",
  "funnel",
  "radar",
  "polar",
  "calendar",
  "sankey",
  "table",
] as const;
export type ExploreChart = (typeof EXPLORE_CHARTS)[number];

/**
 * The floor analytics' cross-filter, as it travels in the address.
 *
 * `pods`, `operators` and `tasks` narrow every question the door is asked. `day` narrows
 * the window to one calendar day, and `hour` (0–23) with it to one hour of that day.
 * `weekday` (1 Monday … 7 Sunday) with `hour` and no day marks a slot of the week on the
 * charts; the door cannot narrow by it. The facets below narrow every chart whose
 * measure counts episodes, and the list of episodes behind a number; a chart whose
 * measure is not about episodes (sessions, signed-in time, vitals) is drawn without them
 * and says so on its card. Facet values are wire keys (lower-cased enum names, or a
 * failure detail's own text): the page reads them back through the generated enums and
 * says so when one is not a value it knows, rather than dropping it.
 */
export const FLOOR_FACETS = ["outcome", "cause", "detail", "stage"] as const;
export type FloorFacet = (typeof FLOOR_FACETS)[number];

export const WEEKDAYS = ["1", "2", "3", "4", "5", "6", "7"] as const;
export type Weekday = (typeof WEEKDAYS)[number];
